import React, { Component } from 'react';
import Formulario from './ProductoForm';
import LoadMask from "../../Utils/LoadMask/LoadMask";

class Producto extends Component{
    state = {
        crear: true,
    }

    componentDidMount = () => {
        const { match, leer, getModulo, listarPrincipios,
            listarLineas, listarForma, listarGrupos, listarFamilias,
            listarConcentracion, limpiarDatos, parametrosEmpresa, listarELZM } = this.props;
        const id = match.params.id;
        if (id){
            this.setState({crear: false});
            leer(id);
        }
        let ruta = window.location.href;
        let modulo = ruta.split('/');
        getModulo(modulo[5],modulo[4])
        localStorage.removeItem('id_detalle_producto_rs');
        listarForma();
        listarGrupos();
        listarPrincipios();
        listarLineas();
        listarFamilias();
        listarConcentracion();
        limpiarDatos();
        parametrosEmpresa();
        listarELZM();
    }
    
    render(){
        const { registroProducto, modificarProducto, loader, modulo,
            listaForm, listaGrupo, lectura, datos,
            listaPrincipio, listaLinea, listaFamilia, listaELZM,
            listaConcentracion, detallePro, agregarLinea, eliminarLinea,
            detalleProducto, agregarLineaProducto, eliminarLineaProducto } = this.props;
        const { crear } = this.state;
        return(
            <LoadMask loading={loader} dark>
                <Formulario
                    crear = {crear}
                    modulo = {modulo}
                    obtenerForma = {listaForm}
                    obtenerGrupos = {listaGrupo}
                    lectura = {lectura}
                    obtenerPrincipio = {listaPrincipio}
                    obtenerLinea = {listaLinea}
                    obtenerFamilia = {listaFamilia}
                    obtenerConcentracion = {listaConcentracion}
                    detallePro = {detallePro}
                    agregarLinea = {agregarLinea}
                    registroProducto = {registroProducto}
                    modificarProducto = {modificarProducto}
                    eliminarLinea = {eliminarLinea}
                    detalleProducto = {detalleProducto}
                    agregarLineaProducto = {agregarLineaProducto}
                    eliminarLineaProducto = {eliminarLineaProducto}
                    datos = {datos}
                    listaELZM = {listaELZM}
                />
            </LoadMask>
        );
    }
}


export default Producto